import React, { ReactNode } from 'react'
import { TextStyle, TouchableOpacity } from 'react-native'
import { BtText } from './BtText'

type LinkProps = {
  onPress: () => void
  title: string
  color?: string
  icon?: ReactNode
  textStyle?: TextStyle
  testID?: string
  disabled?: boolean
}

export const BtLink = ({
  onPress,
  title,
  color,
  icon,
  textStyle,
  testID = 'link',
  disabled = false,
}: LinkProps) => {
  return (
    <TouchableOpacity
      style={{
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onPress={onPress}
      testID={testID}
      disabled={disabled}
    >
      <BtText color={color} weight={'500'} style={textStyle}>
        {title}
      </BtText>
      {icon}
    </TouchableOpacity>
  )
}
